Object.defineProperty(Array.prototype, 'shuffle', {
  value: function(keepOrder) {
    if (!keepOrder) {
      let counter = this.length

      // While there are elements in the this
      while (counter > 0) {
        // Pick a random index
        let index = Math.floor(Math.random() * counter)

        // Decrease counter by 1
        counter -= 1

        // And swap the last element with it
        let temp = this[counter]
        this[counter] = this[index]
        this[index] = temp
      }

      return this
    } else {
      let copy = this.slice()
      let displacement = Math.floor(Math.random() * this.length)
      let n = this.length

      for (let i = 0; i < this.length; i++) {
        this[i] = copy[(((i + displacement) % n) + n) % n]
      }

      return this
    }
  },
})
